module.exports = __webpack_public_path__ + "img/collection-diamondJewelry100Carat@2x.618943d.webp";